var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminalMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 19.5H12.375C12.1562 19.5 12 19.3438 12 19.125V10.875C12 10.6875 12.1562 10.5 12.375 10.5H20.625C20.8125 10.5 21 10.6875 21 10.875V19.125C21 19.3438 20.8125 19.5 20.625 19.5ZM23.5 9.5V22.5C23.5 23.3438 22.8125 24 22 24H11C10.1562 24 9.5 23.3438 9.5 22.5V9.5C9.5 8.6875 10.1562 8 11 8H22C22.8125 8 23.5 8.6875 23.5 9.5ZM22 22.3125V9.6875C22 9.59375 21.9062 9.5 21.8125 9.5H11.1875C11.0625 9.5 11 9.59375 11 9.6875V22.3125C11 22.4375 11.0625 22.5 11.1875 22.5H21.8125C21.9062 22.5 22 22.4375 22 22.3125ZM18.5 21.125C18.5 21.3438 18.3125 21.5 18.125 21.5H14.875C14.6562 21.5 14.5 21.3438 14.5 21.125V20.875C14.5 20.6875 14.6562 20.5 14.875 20.5H18.125C18.3125 20.5 18.5 20.6875 18.5 20.875V21.125Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalMobile);
export default __webpack_public_path__ + "static/media/terminal-mobile.c815553f.svg";
export { ForwardRef as ReactComponent };